export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-w@2x.9f4ac4db.webp";